// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__fRPYe","left":"StickyBox_left__13qt4","right":"StickyBox_right__7s3H0"};